// stolen from from phishermans-friend which stole it from report-tool which got stolen from https://stackoverflow.com/a/77844367

import { effect, signal, Signal } from '@angular/core';

export function debouncedSignal<T>(
  sourceSignal: Signal<T>,
  debounceTimeInMs = 300,
): Signal<T> {
  const debounceSignal = signal(sourceSignal());
  effect((onCleanup) => {
    const value = sourceSignal();
    const timeout = setTimeout(() => {
      debounceSignal.set(value);
    }, debounceTimeInMs);

    // The `onCleanup` argument is a function which is called when the effect
    // runs again (and when it is destroyed).
    // By clearing the timeout here we achieve proper debouncing.
    // See https://angular.io/guide/signals#effect-cleanup-functions
    onCleanup(() => {
      clearTimeout(timeout);
    });
  });

  return debounceSignal;
}
